export function s3JsonPicker(s3Url: string) {
    return fetch(s3Url, {
      headers: {
        'Cache-Control': 'no-cache',
      },
    }).then((response) => response.json());
  }